import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home as HomeIcon } from 'lucide-react';

const PageHero = ({ title, subtitle, breadcrumb }) => (
  <section className="hero-gradient text-white">
    <div className="max-w-7xl mx-auto px-4 py-14 md:py-20">
      <div className="flex items-center gap-1.5 text-sm text-green-100 mb-3">
        <Link to="/" className="hover:text-white flex items-center gap-1"><HomeIcon size={14} /> Home</Link>
        <ChevronRight size={14} />
        <span className="text-white font-medium">{breadcrumb || title}</span>
      </div>
      <h1 className="font-head text-3xl md:text-5xl font-extrabold">{title}</h1>
      {subtitle && <p className="mt-3 text-green-50 max-w-2xl text-lg">{subtitle}</p>}
    </div>
  </section>
);

export default PageHero;
